export default __webpack_public_path__ + "static/media/FlatGenericVerticalFullSize.90ea71ba.png";